'use client';

import 'react-lite-youtube-embed/dist/LiteYouTubeEmbed.css';
import LiteYouTubeEmbed, { type LiteYouTubeProps } from 'react-lite-youtube-embed';

// @source: https://stackoverflow.com/a/9102270
export function getYoutubeId(url: string) {
  const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
  const match = url.match(regExp);
  if (match && match[2].length === 11) {
    return match[2];
  } else {
    return null;
  }
}
export type YouTubeProps = Omit<LiteYouTubeProps, 'id' | 'title'> & {
  title?: string;
  url: string;
};
export function YouTube({
  url,
  title = '',
  ...rest
}: YouTubeProps) {
  const id = getYoutubeId(url);
  if (id) {
    return <LiteYouTubeEmbed id={id} title={title} {...rest} />;
  } else {
    return null;
  }
}